export function EyeOpenIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 8a4 4 0 100 8 4 4 0 000-8zm-2 4a2 2 0 114 0 2 2 0 01-4 0z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M21.832 11.445L21 12l.832.555-.002.003-.003.005-.012.017a11.152 11.152 0 01-.187.265 20.43 20.43 0 01-2.574 2.89C17.372 17.286 14.883 19 12 19c-2.884 0-5.373-1.714-7.053-3.265a20.427 20.427 0 01-2.574-2.89 12.124 12.124 0 01-.148-.207l-.04-.058-.012-.017-.003-.005-.001-.002S2.168 12.555 3 12a165.31 165.31 0 01-.832-.555l.002-.003.003-.005.012-.017.04-.058a18.236 18.236 0 01.7-.927 20.428 20.428 0 012.022-2.17C6.627 6.714 9.116 5 12 5c2.885 0 5.373 1.714 7.053 3.265a20.43 20.43 0 012.575 2.89 12.17 12.17 0 01.187.265l.012.017.003.005.002.003zm-17.35.865a17.76 17.76 0 01-.244-.31 18.439 18.439 0 012.066-2.265C7.872 8.286 9.883 7 12 7c2.116 0 4.127 1.286 5.697 2.735A18.442 18.442 0 0119.762 12a18.442 18.442 0 01-2.066 2.265C16.128 15.714 14.117 17 12 17c-2.115 0-4.127-1.286-5.697-2.735a18.439 18.439 0 01-1.821-1.955z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M21 12l.832-.555c.224.336.224.774 0 1.11L21 12zM2.168 11.445L3 12l-.832.555a1 1 0 010-1.11z"
      ></path>
    </svg>
  );
}
